/**
 * Shared date formatting utility.
 * Standard app format: "dd mmm'yy, hh:mm" in 24hr (e.g. "27 Mar'26, 16:58")
 */

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Format a date to the app-standard format: dd mmm'yy, hh:mm (24hr).
 * @param value  A Date object, ISO string, or null/undefined.
 * @param fallback  Text to return when value is falsy or invalid. Default: 'N/A'.
 */
export function formatAppDate(
    value: Date | string | null | undefined,
    fallback = 'N/A',
): string {
    if (!value) return fallback;
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return fallback;

    const dd = String(d.getDate()).padStart(2, '0');
    const mmm = MONTHS[d.getMonth()];
    const yy = String(d.getFullYear()).slice(-2);
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');

    return `${dd} ${mmm}'${yy}, ${hh}:${min}`;
}
